import EmptyState from '@/components/EmptyState';
import { ImportReviewView } from '@/features/menu/components/ImportReviewView';
import { useMenuTree } from '@/features/menu/hooks/useMenu';
import { useMenuImportReview } from '@/features/menu/hooks/useMenuImportReview';
import { useT } from '@/i18n';
import { useRestaurantStore } from '@/stores/restaurant.store';
import { sectionRouter } from '@/utils/navigateMain';
import { Block, Button, Navbar, Page, Preloader } from 'framework7-react';

interface Props {
  f7route: { params: { menuId: string } };
}

export default function MenuImportReviewPage({ f7route }: Props) {
  const t = useT();
  const c = t.menuImportReview;
  const { menuId } = f7route.params;
  const currency = useRestaurantStore((s) => s.restaurantConfig?.currency) ?? 'EUR';
  const tree = useMenuTree(menuId);
  const review = useMenuImportReview(menuId);
  const live = (tree.data?.liveChannels.length ?? 0) > 0;

  return (
    <Page name="menu-import-review">
      <Navbar title={c.title} backLink={t.back} />
      {review.isLoading && (
        <Block className="text-align-center">
          <Preloader />
        </Block>
      )}
      {review.error && (
        <Block>
          <p style={{ color: 'var(--f7-color-red)' }}>
            {review.error instanceof Error ? review.error.message : t.menu.failedToLoad}
          </p>
          <Button onClick={() => review.refetch()}>{t.shared.retry}</Button>
        </Block>
      )}
      {review.data && (!review.data.available || review.data.pages.length === 0) && (
        <Block data-testid="import-review-unavailable">
          <EmptyState
            icon="doc_text_viewfinder"
            title={c.unavailableTitle}
            description={c.unavailableText}
          />
        </Block>
      )}
      {review.data?.available && review.data.pages.length > 0 && (
        <ImportReviewView
          review={review.data}
          live={live}
          currency={currency}
          onOpenDish={(dish) =>
            sectionRouter()?.navigate(`/menu/${menuId}/product/${dish.productId}`)
          }
        />
      )}
    </Page>
  );
}
